module.exports = __webpack_public_path__ + "media/images/icon_li-10aecc7fe1bc25e482e4b9a6ca3b4a8a.png";